import { css, Global } from '@emotion/react';
import React from 'react';
import calender from '../../images/svgs/calender.svg';

export const colors = {
    blueLight: '#4BCDF9',
    blueMedium: '#0A75F3',
    blueDark: '#103592',
    blueExtraDark: '#2D3956',
    black: '#26292B',
    grey: '#E5EEF1',
    yellow: '#F2F2E3',
    white: '#FFFFFF',
};

const size = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '400px',
    tablet: '768px',
    laptop: '1020px',
    laptopL: '1280px',
    desktop: '1540px',
    desktopL: '1820px',
};

export const device = {
    mobileS: `(min-width: ${size.mobileS})`,
    mobileM: `(min-width: ${size.mobileM})`,
    mobileL: `(min-width: ${size.mobileL})`,
    tablet: `(min-width: ${size.tablet})`,
    laptop: `(min-width: ${size.laptop})`,
    laptopL: `(min-width: ${size.laptopL})`,
    desktop: `(min-width: ${size.desktop})`,
    desktopL: `(min-width: ${size.desktopL})`,
};

export const GlobalStyles: React.FC = () => {
    return (
        <Global
            styles={css`
                html {
                    box-sizing: border-box;
                    font-size: 100%;
                    overflow-x: hidden;
                    -ms-text-size-adjust: 100%;
                    -webkit-text-size-adjust: 100%;
                    scroll-behavior: smooth;
                }

                body {
                    background: ${colors.white};
                    font-weight: normal;
                    font-size: 1rem;
                    word-wrap: break-word;
                    font-kerning: normal;
                    overflow-x: hidden;
                    word-wrap: break-word;
                    margin: 0;
                    -webkit-font-smoothing: antialiased;
                }

                .image {
                    position: relative;
                }
                .underlayer {
                    opacity: 0.7;
                    filter: blur(41px);
                    border-radius: 20px;
                    position: absolute;
                    top: 2em;
                    left: 2.5em;
                    width: 80%;
                }
                * {
                    font-family: 'Poppins';
                    margin: 0;
                    transition: 0.2s all;
                }
                .margin {
                    margin: 2em 0em;
                }
                .container {
                    max-width: 1200px;
                    margin: 0 auto;
                }
                .blue-medium {
                    color: ${colors.blueMedium};
                }
                .blue-dark {
                    color: ${colors.blueDark};
                }
                .blue-extra-dark {
                    color: ${colors.blueExtraDark};
                }
                .container-header {
                    background: teal;
                    max-width: 1200px;
                }
                h1 {
                    font-size: 40px;
                    line-height: 44.8px;
                }
                p {
                    color: ${colors.black};
                }
                h1 {
                }
                h2 {
                    font-size: 42px;
                    line-height: 62px;
                    font-weight: 600;
                    color: ${colors.blueDark};
                }
                h3 {
                    font-size: 34px;
                }
                p {
                    line-height: 33px;
                    font-size: 1em;
                }
                a {
                    text-decoration: none;
                }
                *,
                *:before,
                *:after {
                    box-sizing: border-box;
                }

                img {
                    max-width: 100%;
                    display: block;
                }
                ul {
                    padding-left: 0;
                }
                button,
                input,
                optgroup,
                select,
                textarea {
                    margin: 0;
                }
                button {
                    cursor: pointer;
                }
                button,
                input {
                }
                ::-webkit-input-placeholder {
                    color: inherit;
                    opacity: 0.54;
                }
                ::-webkit-file-upload-button {
                    -webkit-appearance: button;
                    font: inherit;
                }
                input[type='time']:focus {
                    outline: 1.5px solid ${colors.blueDark}; /* oranges! yey */
                    /* border: none; */
                    border: none;
                    border-radius: 3px;
                }
                input[type='text']:focus {
                    outline: 1.5px solid ${colors.blueDark}; /* oranges! yey */
                    /* border: none; */
                    border: none;
                    border-radius: 3px;
                }
                input[type='email']:focus {
                    outline: 1.5px solid ${colors.blueDark}; /* oranges! yey */
                    /* border: none; */
                    border: none;
                    border-radius: 3px;
                }
                input[type='tel']:focus {
                    outline: 1.5px solid ${colors.blueDark}; /* oranges! yey */
                    /* border: none; */
                    border: none;
                    border-radius: 3px;
                }
                input[type='date']:focus {
                    outline: 1.5px solid ${colors.blueDark}; /* oranges! yey */
                    /* border: none; */
                    border: none;
                    border-radius: 3px;
                }
                input[type='date']::-webkit-calendar-picker-indicator {
                    position: relative;
                    right: 0.6em;
                    fill: red;
                    top: 0.32em;
                    height: 30px;
                    background: url(${calender}) no-repeat;
                    -webkit-appearance: none;
                }

                textarea:focus {
                    outline: 2px solid ${colors.blueDark}; /* oranges! yey */
                    border: none;
                }
                .image-container {
                    position: relative;
                }

                .underlayer {
                    position: absolute;
                    top: 0em;
                    filter: blur(20px);
                    width: 74%;
                    left: 2em;
                    top: 2.4em;
                }

                @media ${device.mobileL} {
                }
                @media ${device.tablet} {
                    .margin {
                        margin: 5em 0em;
                    }
                    .container {
                        max-width: 720px;
                        margin: 0 auto;
                    }
                    h1 {
                        font-size: 40px;
                        line-height: 44.8px;
                    }
                    h1,
                    h2 {
                        font-size: 42px;
                        line-height: 62.24px;
                        font-weight: 600;
                    }

                    h3 {
                        font-size: 34px;
                    }
                }
                @media ${device.laptop} {
                    .container {
                        position: relative;
                        max-width: 920px;
                    }
                    .container {
                        max-width: 920px;
                    }
                }

                @media ${device.laptopL} {
                    .margin {
                        margin: 7em 0em;
                    }
                    .special-case {
                        padding: 0.5em 0em;
                        text-align: center;
                    }

                    .container {
                        max-width: 1165px;
                        margin: 0 auto;
                    }
                    h1 {
                        font-size: 64px;
                        line-height: 66px;
                    }
                    h2 {
                        font-style: normal;
                        font-weight: 600;
                        font-size: 40px;
                        line-height: 60px;
                    }
                }
                @media ${device.desktop} {
                    h2 {
                        font-size: 48px;
                    }
                }
                @media ${device.desktopL} {
                    p {
                        font-size: 1.2em;
                    }
                    h1 {
                        font-size: 60px;
                        line-height: 66px;
                    }
                    h2 {
                        font-size: 58px;
                        line-height: 66px;
                    }
                    h3 {
                        font-size: 48px;
                    }

                    .container {
                        max-width: 1265px;
                        margin: 0 auto;
                    }
                    .container {
                        max-width: 1265px;
                    }
                }
            `}
        />
    );
};
